import app from './app'
import auth from './auth'
import user from './user'
import toast from './toast'
import managers from './managers'
import logs from './logs'
import positions from './positions'
import application from './application'
import finances from './finances'
import tariffs from './tariffs'
import payments from './payments'

export default {
  app,
  auth,
  user,
  toast,
  managers,
  logs,
  positions,
  application,
  finances,
  tariffs,
  payments,
}
